import React, { Component } from 'react'
import './styles.css'
import { apiEmployee } from '../../../services/apiamrg'
import Header from '../../../components/header'
import Rodape from '../../../components/rodape'
import loader from '../../../classes/loader'
import Skeleton from '../../../components/skeleton'
import AddButton from '../../../components/addButton';
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { PRECISA_LOGAR, NOME_EMPRESA } from '../../../config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faPen, faPlus, faEnvelope, faHome, faChevronDown, faChevronUp, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import moment from 'moment'
import ModalItem from '../../../components/modalItem'
import { Formik, Form } from 'formik'
import { PDFExport } from "@progress/kendo-react-pdf"


const estadoInicial = {
    name: '',
    pessoas: [],
    pesquisa: "",
    tipoPesquisa: 1,
    categoria: "",
    //Tipos de pesquisa: 1 (descricao), 2 (prazo)
    /*seaports: [],*/
    loading: true,
    redirect: false,
    chaveFocus: '',

    deletePessoa: false,

    modalItemAberto: false,
    itemPermissao: '',
    itemInfo: [],
    itemNome: '',
    itemChave: '',
    itemAdd: {},
    itemEdit: {},
    itemFinanceiro: {},
    itemDelete: '',

    direcaoTabela: faChevronDown,
    acessos: [],
    permissoes: [],
    acessosPermissoes: [],

    modalRelatorio: false,
    categoriasRelatorio: {
        cliente: false,
        fornecedor: false,
        banco: false,
        broker: false
    },
    pessoasFiltradas: null,
    categoriasNomesSelecionadas: null
}

class Pessoas extends Component {

    constructor(props) {
        super(props);
        this.pdfExportComponent = React.createRef();
    }

    state = {
        ...estadoInicial,
        usuarioLogado: this.props.user
    }

    componentDidMount = async () => {
        await this.loadAll();

        if (this.state.chaveFocus) {
            if (this.refs.focusMe) {
                await this.refs.focusMe.focus();
            } else {
                await this.setState({ pesquisa: this.state.chaveFocus, tipoPesquisa: 3 })
            }
        }

        this.state.acessosPermissoes.map((e) => {
            if (e.acessoAcao == "PESSOAS" && e.permissaoConsulta == 0) {
                this.setState({ redirect: true })
            }
        })
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (this.state.deletePessoa && this.state.modalItemAberto != prevState.modalItemAberto) {
            await this.setState({
                modalItemAberto: false,
                deletePessoa: false
            })
        }
    }

    loadAll = async () => {
        await this.setState({
            pessoas: await loader.getBase('getPessoas.php'),
            acessos: await loader.getBase('getTiposAcessos.php'),
            permissoes: await loader.getBase('getPermissoes.php')
        })
        console.log(this.state.pessoas);
        
        if (this.props.location.state && this.props.location.state.chave) {
            await this.setState({ chaveFocus: this.props.location.state.chave });
        }

        await this.setState({
            acessosPermissoes: await loader.testaAcesso(this.state.acessos, this.state.permissoes, this.state.usuarioLogado),
            loading: false,
        })
    }

    erroApi = async () => {
        console.log(PRECISA_LOGAR)
        await this.setState({ redirect: true })
    }

    deletePessoa = async (chave, nome) => {
        this.setState({ deletePessoa: true })
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>{NOME_EMPRESA}</h1>
                        <p>Deseja remover esta Pessoa? ({nome}) </p>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-danger w-25"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Não
                        </button>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-25"
                            onClick={
                                async () => {
                                    await apiEmployee.post(`deletePessoa.php`, {
                                        token: true,
                                        chave: chave
                                    }).then(
                                        async response => {
                                            if (response.data == true) {
                                                await loader.salvaLogs('pessoas', this.state.usuarioLogado.codigo, null, "Exclusão", chave);

                                                document.location.reload()
                                            }
                                        },
                                        async response => {
                                            this.erroApi(response)
                                        }
                                    )
                                    onClose()
                                }
                            }

                        >
                            Sim
                        </button>
                    </div>
                )
            }
        })
    }

    reverterItens = async () => {
        await this.setState({ loading: true })
        const pessoas = this.state.pessoas.reverse();

        if (this.state.direcaoTabela == faChevronDown) {
            await this.setState({ direcaoTabela: faChevronUp });
        } else {
            await this.setState({ direcaoTabela: faChevronDown });
        }

        await this.setState({ pessoas, loading: false });
    }

    filtrarPesquisa = (pessoas) => {
        // Filtro por categoria (verificar bit específico)
        if (this.state.categoria) {
            const subCategoria = pessoas.Categoria || '0';
            const posicao = parseInt(this.state.categoria) - 1;
            
            // Verificar se o bit na posição está ativo (1)
            if (subCategoria.length < posicao || subCategoria[posicao] != '1') {
                return false;
            }
        }

        // Filtro por pesquisa
        if (this.state.tipoPesquisa == 1) {
            return pessoas.Nome.toLowerCase().includes(this.state.pesquisa.toLowerCase())
        } else if (this.state.tipoPesquisa == 2) {
            return pessoas.Cnpj_Cpf.toLowerCase().includes(this.state.pesquisa.toLowerCase())
        } else {
            return pessoas.Chave.toLowerCase().includes(this.state.pesquisa.toLowerCase())
        }

    }

    gerarRelatorioPDF = async () => {
        const { categoriasRelatorio, pessoas } = this.state;
        
        // Verificar se pelo menos uma categoria foi selecionada
        const algumaSelecionada = Object.values(categoriasRelatorio).some(v => v === true);
        
        if (!algumaSelecionada) {
            alert("Por favor, selecione pelo menos uma categoria para gerar o relatório.");
            return;
        }

        this.setState({ loading: true, modalRelatorio: false });

        try {
            // Mapear categorias para posições no bit string
            const categoriasPosicao = {
                cliente: 0,
                fornecedor: 1,
                agente: 2,
                armador: 3,
                banco: 4,
                broker: 5,
                outros: 6
            };

            // Filtrar pessoas pelas categorias selecionadas
            const pessoasFiltradas = pessoas.filter(pessoa => {
                const categoria = pessoa.Categoria || '0000000';
                
                // Verificar se a pessoa pertence a alguma categoria selecionada
                for (const [key, selected] of Object.entries(categoriasRelatorio)) {
                    if (selected) {
                        const posicao = categoriasPosicao[key];
                        if (categoria[posicao] === '1') {
                            return true;
                        }
                    }
                }
                return false;
            });

            if (pessoasFiltradas.length === 0) {
                alert("Nenhuma pessoa encontrada nas categorias selecionadas.");
                this.setState({ loading: false });
                return;
            }

            // Criar nomes das categorias selecionadas
            const categoriasNomes = [];
            if (categoriasRelatorio.cliente) categoriasNomes.push('Cliente');
            if (categoriasRelatorio.fornecedor) categoriasNomes.push('Fornecedor');
            if (categoriasRelatorio.banco) categoriasNomes.push('Banco');
            if (categoriasRelatorio.broker) categoriasNomes.push('Broker');

            // Armazenar dados no state para o render
            await this.setState({ 
                pessoasFiltradas,
                categoriasNomesSelecionadas: categoriasNomes
            });

            // Aguardar um pouco para garantir que o componente foi renderizado
            setTimeout(() => {
                if (this.pdfExportComponent.current) {
                    const nomeArquivo = `Relatorio_Pessoas_${categoriasNomes.join('_')}_${moment().format('DD-MM-YYYY_HH-mm')}.pdf`;
                    this.pdfExportComponent.current.save();
                }
                
                // Resetar o state após gerar o PDF
                setTimeout(() => {
                    this.setState({ 
                        loading: false,
                        pessoasFiltradas: null,
                        categoriasNomesSelecionadas: null,
                        categoriasRelatorio: {
                            cliente: false,
                            fornecedor: false,
                            banco: false,
                            broker: false
                        }
                    });
                }, 1000);
            }, 100);

        } catch (error) {
            console.error('Erro ao gerar relatório:', error);
            alert('Erro ao gerar relatório. Por favor, tente novamente.');
            this.setState({ loading: false });
        }
    }



    render() {

        return (

            <div className='allContent'>

                <div>
                    {this.state.loading &&
                        <Skeleton />
                    }

                    {this.state.redirect &&
                        <Redirect to={'/'} />
                    }

                    {!this.state.loading &&
                        <div>
                            <section>
                                <Header voltarTabelas pessoas titulo="Pessoas" />


                                <br />
                            </section>

                            <ModalItem
                                closeModal={() => { this.setState({ modalItemAberto: false }) }}
                                itens={this.state.itemInfo}
                                nome={this.state.itemNome}
                                chave={this.state.itemChave}
                                modalAberto={this.state.modalItemAberto}
                                itemPermissao={this.state.itemPermissao}
                                itemAdd={this.state.itemAdd}
                                itemEdit={this.state.itemEdit}
                                itemContatos={this.state.itemContatos}
                                itemEnderecos={this.state.itemEnderecos}
                                itemDelete={this.state.itemDelete}
                                acessosPermissoes={this.state.acessosPermissoes}
                            />

                            <AddButton addLink={{ pathname: `/tabelas/addpessoa/0` }}/>

                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left">
                                <div className="row mobileajuster3">
                                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 sumir">
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  text-right pesquisa mobileajuster1 ">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  text-right pesquisa mobileajuster1 ">
                                            <div className='col-1'></div>
                                            <span style={{marginRight: 8, fontSize: '1.1em', fontWeight: '500'}}>Categoria:</span>
                                            <select className="form-control tipoPesquisa col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2" placeholder="Categoria..." value={this.state.categoria} onChange={e => { this.setState({ categoria: e.currentTarget.value }) }}>
                                                <option value="">Todas</option>
                                                <option value="1">Cliente</option>
                                                <option value="2">Fornecedor</option>
                                                <option value="5">Banco</option>
                                                <option value="6">Broker</option>
                                            </select>
                                            <select className="form-control tipoPesquisa col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2" placeholder="Tipo de pesquisa..." value={this.state.tipoPesquisa} onChange={e => { this.setState({ tipoPesquisa: e.currentTarget.value }) }}>
                                                <option value={1}>Nome</option>
                                                <option value={2}>CPF/CNPJ</option>
                                                <option value={3}>Chave</option>
                                            </select>
                                            <input className="form-control campoPesquisa col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" placeholder="Pesquise aqui..." value={this.state.pesquisa} onChange={e => { this.setState({ pesquisa: e.currentTarget.value }) }} />
                                            {this.state.acessosPermissoes.filter(e => e.acessoAcao == "PESSOAS").map(e => e.permissaoImprime)[0] == 1 && (
                                                <div className="dropdown" style={{ marginLeft: 15 }}>
                                                    <button className="btn btn-success dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        Relatório
                                                    </button>
                                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); this.setState({ modalRelatorio: true }); }}>Exportar para PDF</a>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="col-7 col-sm-3 col-md-2 col-lg-2 col-xl-2 text-left">
                                                <Link to={{ pathname: `/tabelas/addpessoa/0` }}><button className="btn btn-success">+</button></Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-0 col-sm-0 col-md-3 col-lg-3 col-xl-3"></div>
                                    <div>
                                    </div>

                                </div>
                            </div>


                            <div className="row deleteMargin" id="product-list">
                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-0"></div>
                                <div className="col-lg-8 col-md-8 col-sm-12 col-12 mix all dresses bags">
                                    <div className="single-product-item" >
                                        {window.innerWidth >= 500 &&
                                            <div className="row subtitulosTabela">
                                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-left">
                                                    <span className="subtituloships">Chave</span>
                                                </div>
                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-left">
                                                    <span className="subtituloships">Cnpj / Cpf</span>
                                                </div>
                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-left">
                                                    <span className="subtituloships">Pessoa</span>
                                                </div>
                                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-left">
                                                    <span className="subtituloships">Info</span>
                                                </div>
                                                <div className="col-2 text-right revertItem" onClick={() => this.reverterItens()}>
                                                    <span className="subtituloships"><FontAwesomeIcon icon={this.state.direcaoTabela} /></span>
                                                </div>
                                            </div>
                                        }
                                        {window.innerWidth < 500 &&
                                            <div className="row subtitulosTabela">
                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-left">
                                                    <span className="subtituloships">Cnpj / Cpf</span>
                                                </div>
                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-left">
                                                    <span className="subtituloships">Pessoa</span>
                                                </div>
                                                <div className="col-2 text-left">
                                                    <span className="subtituloships">Info</span>
                                                </div>
                                                <div className="col-2 text-right revertItem" onClick={() => this.reverterItens()}>
                                                    <span className="subtituloships"><FontAwesomeIcon icon={this.state.direcaoTabela} /></span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-0"></div>
                            </div>

                            <div id="product-list">
                                {this.state.pessoas[0] != undefined && this.state.pessoas.filter(this.filtrarPesquisa).map((feed, index) => (
                                    <div key={feed.Chave} className="row row-list">
                                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-0"></div>
                                        <div ref={feed.Chave == this.state.chaveFocus ? "focusMe" : ""} tabindex={-1} key={feed.id} className={`col-lg-8 col-md-8 col-sm-12 mix all dresses bags ${index % 2 == 0 ? feed.Chave == this.state.chaveFocus ? "par focusLight" : "par " : feed.Chave == this.state.chaveFocus ? "impar focusDark" : "impar"}`}>
                                            {window.innerWidth >= 500 &&
                                                <div className="row deleteMargin alignCenter">
                                                    <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-left">
                                                        <p>{feed.Chave}</p>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-left" style={{ overflowWrap: 'anywhere' }}>
                                                        <p>{feed.Cnpj_Cpf}</p>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-left">
                                                        <p>{feed.Nome_Fantasia ? feed.Nome_Fantasia : feed.Nome}</p>
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-2  text-left  mobileajuster4 icones">
                                                        {this.state.acessosPermissoes.filter((e) => { if (e.acessoAcao == 'PESSOAS_CONTATOS') { return e } }).map((e) => e.permissaoConsulta)[0] == 1 &&
                                                            <div className='iconelixo giveMargin' type='button' >
                                                                <Link to=
                                                                    {{
                                                                        pathname: `/tabelas/pessoacontatos/${feed.Chave}`,
                                                                        state: { pessoa: { ...feed } }
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon icon={faEnvelope} />
                                                                </Link>
                                                            </div>
                                                        }

                                                        {this.state.acessosPermissoes.filter((e) => { if (e.acessoAcao == 'PESSOAS_ENDERECOS') { return e } }).map((e) => e.permissaoConsulta)[0] == 1 &&
                                                            <div className='iconelixo giveMargin' type='button' >
                                                                <Link to=
                                                                    {{
                                                                        pathname: `/tabelas/pessoaenderecos/${feed.Chave}`,
                                                                        state: { pessoa: { ...feed } }
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon icon={faHome} />
                                                                </Link>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-2  text-left  mobileajuster4 icones">
                                                        <div className='iconelixo giveMargin' type='button' >
                                                            <Link to=
                                                                {{
                                                                    pathname: `/tabelas/addpessoa/0`,
                                                                    state: { pessoa: { ...feed } }
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faPlus} />
                                                            </Link>
                                                        </div>


                                                        <div className='iconelixo giveMargin' type='button' >
                                                            <Link to=
                                                                {{
                                                                    pathname: `/tabelas/addpessoa/${feed.Chave}`,
                                                                    state: { pessoa: { ...feed } }
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faPen} />
                                                            </Link>
                                                        </div>

                                                        {this.state.acessosPermissoes.filter((e) => { if (e.acessoAcao == 'PESSOAS') { return e } }).map((e) => e.permissaoDeleta)[0] == 1 &&
                                                            <div type='button' className='iconelixo' onClick={(a) => this.deletePessoa(feed.Chave, feed.Nome)} >
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </div>
                                                        }
                                                    </div>

                                                </div>
                                            }
                                            {window.innerWidth < 500 &&
                                                <div
                                                    onClick={() => {
                                                        this.setState({

                                                            modalItemAberto: true,
                                                            itemInfo: [
                                                                { titulo: 'Chave', valor: feed.Chave },
                                                                { titulo: 'Nome', valor: feed.Nome },
                                                                { titulo: 'Nome Fantasia', valor: feed.Nome_Fantasia },
                                                                { titulo: 'CPF/CNPJ', valor: feed.Cnpj_Cpf },
                                                                { titulo: 'RG/IE', valor: feed.Rg_Ie },
                                                                { titulo: 'Nascimento/Abertura', valor: moment(feed.Nascimento_Abertura).format('DD/MM/YYYY') != "Invalid date" ? moment(feed.Nascimento_Abertura).format('DD/MM/YYYY') : '' }
                                                            ],
                                                            itemPermissao: 'PESSOAS',
                                                            itemNome: feed.Nome,
                                                            itemChave: feed.Chave,
                                                            itemAdd: {
                                                                pathname: `/tabelas/addmoeda/0`,
                                                                state: { moeda: { ...feed } }
                                                            },
                                                            itemEdit: {
                                                                pathname: `/tabelas/addmoeda/${feed.Chave}`,
                                                                state: { moeda: { ...feed } }
                                                            },
                                                            itemContatos: this.state.acessosPermissoes.filter((e) => { if (e.acessoAcao == 'PESSOAS_CONTATOS') { return e } }).map((e) => e.permissaoConsulta)[0] == 1 ? {
                                                                pathname: `/tabelas/pessoacontatos/${feed.Chave}`,
                                                                state: { pessoa: { ...feed } }
                                                            } : '',
                                                            itemEnderecos: this.state.acessosPermissoes.filter((e) => { if (e.acessoAcao == 'PESSOAS_ENDERECOS') { return e } }).map((e) => e.permissaoConsulta)[0] == 1 ? {
                                                                pathname: `/tabelas/pessoaenderecos/${feed.Chave}`,
                                                                state: { pessoa: { ...feed } }
                                                            } : '',
                                                            itemDelete: this.deletePessoa
                                                        })
                                                    }}
                                                    className="row deleteMargin alignCenter">
                                                    <div className="col-4 text-left" style={{ overflowWrap: 'anywhere' }}>
                                                        <p>{feed.Cnpj_Cpf}</p>
                                                    </div>
                                                    <div className="col-4 text-left">
                                                        <p>{feed.Nome_Fantasia ? feed.Nome_Fantasia : feed.Nome}</p>
                                                    </div>
                                                    <div className="col-2  text-left  mobileajuster4 icones">
                                                        {this.state.acessosPermissoes.filter((e) => { if (e.acessoAcao == 'PESSOAS_CONTATOS') { return e } }).map((e) => e.permissaoConsulta)[0] == 1 &&
                                                            <div className='iconelixo giveMargin' type='button' >
                                                                <Link to=
                                                                    {{
                                                                        pathname: `/tabelas/pessoacontatos/${feed.Chave}`,
                                                                        state: { pessoa: { ...feed } }
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon icon={faEnvelope} />
                                                                </Link>
                                                            </div>
                                                        }

                                                        {this.state.acessosPermissoes.filter((e) => { if (e.acessoAcao == 'PESSOAS_ENDERECOS') { return e } }).map((e) => e.permissaoConsulta)[0] == 1 &&
                                                            <div className='iconelixo giveMargin' type='button' >
                                                                <Link to=
                                                                    {{
                                                                        pathname: `/tabelas/pessoaenderecos/${feed.Chave}`,
                                                                        state: { pessoa: { ...feed } }
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon icon={faHome} />
                                                                </Link>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="col-2  text-left  mobileajuster4 icones">
                                                        <div className='iconelixo giveMargin' type='button' >
                                                            <Link to=
                                                                {{
                                                                    pathname: `/tabelas/addpessoa/0`,
                                                                    state: { pessoa: { ...feed } }
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faPlus} />
                                                            </Link>
                                                        </div>


                                                        <div className='iconelixo giveMargin' type='button' >
                                                            <Link to=
                                                                {{
                                                                    pathname: `/tabelas/addpessoa/${feed.Chave}`,
                                                                    state: { pessoa: { ...feed } }
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faPen} />
                                                            </Link>
                                                        </div>

                                                        {this.state.acessosPermissoes.filter((e) => { if (e.acessoAcao == 'PESSOAS') { return e } }).map((e) => e.permissaoDeleta)[0] == 1 &&
                                                            <div type='button' className='iconelixo' onClick={(a) => this.deletePessoa(feed.Chave, feed.Nome)} >
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-0"></div>
                                    </div>
                                ))}
                            </div>

                            {/* Modal de Relatório */}
                            {this.state.modalRelatorio && (
                                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1050 }}>
                                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '500px' }}>
                                        <div className="modal-content" style={{ borderRadius: '10px', overflow: 'hidden', border: 'none' }}>
                                            <div className="modal-header" style={{ 
                                                backgroundColor: '#0d315e', 
                                                color: 'white',
                                                padding: '20px 30px',
                                                border: 'none'
                                            }}>
                                                <h5 className="modal-title" style={{ fontWeight: '600', fontSize: '20px' }}>Relatório de Pessoas</h5>
                                                <button type="button" className="close" style={{ color: 'white', opacity: 1, textShadow: 'none' }} onClick={() => this.setState({ modalRelatorio: false })}>
                                                    <span style={{ fontSize: '30px' }}>&times;</span>
                                                </button>
                                            </div>
                                            <Formik
                                                initialValues={{}}
                                                onSubmit={async (values) => {
                                                    await this.gerarRelatorioPDF();
                                                }}
                                            >
                                                <Form className="contact-form">
                                                    <div className="modal-body" style={{ padding: '30px', backgroundColor: '#fff' }}>
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <p style={{ 
                                                                    marginBottom: '20px', 
                                                                    fontSize: '15px', 
                                                                    color: '#495057',
                                                                    textAlign: 'center'
                                                                }}>
                                                                    Selecione as categorias para incluir no relatório:
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                                                    <label style={{ 
                                                                        display: 'flex', 
                                                                        alignItems: 'center', 
                                                                        cursor: 'pointer',
                                                                        padding: '15px 18px',
                                                                        backgroundColor: this.state.categoriasRelatorio.cliente ? '#cfe2ff' : 'white',
                                                                        border: this.state.categoriasRelatorio.cliente ? '2px solid #0d315e' : '2px solid #e0e0e0',
                                                                        borderRadius: '6px',
                                                                        transition: 'all 0.2s ease',
                                                                        boxShadow: this.state.categoriasRelatorio.cliente ? '0 2px 8px rgba(0, 123, 255, 0.2)' : 'none'
                                                                    }}>
                                                                        <input 
                                                                            type="checkbox" 
                                                                            id="checkCliente"
                                                                            checked={this.state.categoriasRelatorio.cliente}
                                                                            onChange={(e) => this.setState({ 
                                                                                categoriasRelatorio: { 
                                                                                    ...this.state.categoriasRelatorio, 
                                                                                    cliente: e.target.checked 
                                                                                }
                                                                            })}
                                                                            style={{ 
                                                                                width: '18px', 
                                                                                height: '18px', 
                                                                                marginRight: '12px',
                                                                                cursor: 'pointer',
                                                                                accentColor: '#0d315e'
                                                                            }}
                                                                        />
                                                                        <span style={{ fontSize: '15px', fontWeight: '500', color: '#212529' }}>
                                                                            Cliente
                                                                        </span>
                                                                    </label>

                                                                    <label style={{ 
                                                                        display: 'flex', 
                                                                        alignItems: 'center', 
                                                                        cursor: 'pointer',
                                                                        padding: '15px 18px',
                                                                        backgroundColor: this.state.categoriasRelatorio.fornecedor ? '#cfe2ff' : 'white',
                                                                        border: this.state.categoriasRelatorio.fornecedor ? '2px solid #0d315e' : '2px solid #e0e0e0',
                                                                        borderRadius: '6px',
                                                                        transition: 'all 0.2s ease',
                                                                        boxShadow: this.state.categoriasRelatorio.fornecedor ? '0 2px 8px rgba(0, 123, 255, 0.2)' : 'none'
                                                                    }}>
                                                                        <input 
                                                                            type="checkbox" 
                                                                            id="checkFornecedor"
                                                                            checked={this.state.categoriasRelatorio.fornecedor}
                                                                            onChange={(e) => this.setState({ 
                                                                                categoriasRelatorio: { 
                                                                                    ...this.state.categoriasRelatorio, 
                                                                                    fornecedor: e.target.checked 
                                                                                }
                                                                            })}
                                                                            style={{ 
                                                                                width: '18px', 
                                                                                height: '18px', 
                                                                                marginRight: '12px',
                                                                                cursor: 'pointer',
                                                                                accentColor: '#0d315e'
                                                                            }}
                                                                        />
                                                                        <span style={{ fontSize: '15px', fontWeight: '500', color: '#212529' }}>
                                                                            Fornecedor
                                                                        </span>
                                                                    </label>

                                                                    <label style={{ 
                                                                        display: 'flex', 
                                                                        alignItems: 'center', 
                                                                        cursor: 'pointer',
                                                                        padding: '15px 18px',
                                                                        backgroundColor: this.state.categoriasRelatorio.banco ? '#cfe2ff' : 'white',
                                                                        border: this.state.categoriasRelatorio.banco ? '2px solid #0d315e' : '2px solid #e0e0e0',
                                                                        borderRadius: '6px',
                                                                        transition: 'all 0.2s ease',
                                                                        boxShadow: this.state.categoriasRelatorio.banco ? '0 2px 8px rgba(0, 123, 255, 0.2)' : 'none'
                                                                    }}>
                                                                        <input 
                                                                            type="checkbox" 
                                                                            id="checkBanco"
                                                                            checked={this.state.categoriasRelatorio.banco}
                                                                            onChange={(e) => this.setState({ 
                                                                                categoriasRelatorio: { 
                                                                                    ...this.state.categoriasRelatorio, 
                                                                                    banco: e.target.checked 
                                                                                }
                                                                            })}
                                                                            style={{ 
                                                                                width: '18px', 
                                                                                height: '18px', 
                                                                                marginRight: '12px',
                                                                                cursor: 'pointer',
                                                                                accentColor: '#0d315e'
                                                                            }}
                                                                        />
                                                                        <span style={{ fontSize: '15px', fontWeight: '500', color: '#212529' }}>
                                                                            Banco
                                                                        </span>
                                                                    </label>

                                                                    <label style={{ 
                                                                        display: 'flex', 
                                                                        alignItems: 'center', 
                                                                        cursor: 'pointer',
                                                                        padding: '15px 18px',
                                                                        backgroundColor: this.state.categoriasRelatorio.broker ? '#cfe2ff' : 'white',
                                                                        border: this.state.categoriasRelatorio.broker ? '2px solid #0d315e' : '2px solid #e0e0e0',
                                                                        borderRadius: '6px',
                                                                        transition: 'all 0.2s ease',
                                                                        boxShadow: this.state.categoriasRelatorio.broker ? '0 2px 8px rgba(0, 123, 255, 0.2)' : 'none'
                                                                    }}>
                                                                        <input 
                                                                            type="checkbox" 
                                                                            id="checkBroker"
                                                                            checked={this.state.categoriasRelatorio.broker}
                                                                            onChange={(e) => this.setState({ 
                                                                                categoriasRelatorio: { 
                                                                                    ...this.state.categoriasRelatorio, 
                                                                                    broker: e.target.checked 
                                                                                }
                                                                            })}
                                                                            style={{ 
                                                                                width: '18px', 
                                                                                height: '18px', 
                                                                                marginRight: '12px',
                                                                                cursor: 'pointer',
                                                                                accentColor: '#0d315e'
                                                                            }}
                                                                        />
                                                                        <span style={{ fontSize: '15px', fontWeight: '500', color: '#212529' }}>
                                                                            Broker
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer" style={{ 
                                                        padding: '20px 30px',
                                                        backgroundColor: '#f8f9fa',
                                                        border: 'none',
                                                        display: 'flex',
                                                        justifyContent: 'space-between'
                                                    }}>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-secondary" 
                                                            onClick={() => this.setState({ modalRelatorio: false })}
                                                            style={{
                                                                padding: '10px 25px',
                                                                fontWeight: '500',
                                                                borderRadius: '5px'
                                                            }}
                                                        >
                                                            Cancelar
                                                        </button>
                                                        <button 
                                                            type="submit" 
                                                            className="btn btn-primary" 
                                                            disabled={this.state.loading}
                                                            style={{
                                                                padding: '10px 30px',
                                                                fontWeight: '500',
                                                                borderRadius: '5px',
                                                                color: 'white',
                                                                backgroundColor: '#0d315e',
                                                                border: 'none'
                                                            }}
                                                        >
                                                            {this.state.loading ? 'Gerando...' : 'Gerar Relatório'}
                                                        </button>
                                                    </div>
                                                </Form>
                                            </Formik>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    }

                    {/* PDFExport Component - Hidden */}
                    {this.state.pessoasFiltradas && (
                        <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
                            <PDFExport
                                paperSize="A4"
                                margin="1cm"
                                scale={0.6}
                                fileName={`Relatorio_Pessoas_${this.state.categoriasNomesSelecionadas?.join('_')}_${moment().format('DD-MM-YYYY_HH-mm')}.pdf`}
                                ref={this.pdfExportComponent}
                            >
                                <div style={{ 
                                    fontFamily: 'Arial, Helvetica, sans-serif',
                                    padding: '30px',
                                    backgroundColor: 'white'
                                }}>
                                    {/* Header */}
                                    <div style={{ 
                                        textAlign: 'center', 
                                        marginBottom: '30px', 
                                        borderBottom: '3px solid #0d315e', 
                                        paddingBottom: '20px' 
                                    }}>
                                        <img 
                                            src="https://i.ibb.co/MyqWLrY6/logo.png" 
                                            alt="Grifo Logo" 
                                            style={{ width: '200px', height: 'auto', marginBottom: '15px' }} 
                                        />
                                        <h1 style={{ color: '#333', fontSize: '28px', marginBottom: '10px' }}>
                                            Relatório de Pessoas
                                        </h1>
                                    </div>

                                    {/* Info Section */}
                                    <div style={{ 
                                        backgroundColor: '#e7f3ff', 
                                        padding: '15px', 
                                        borderRadius: '5px', 
                                        marginBottom: '25px', 
                                        borderLeft: '4px solid #0d315e' 
                                    }}>
                                        <p style={{ margin: '8px 0', fontSize: '14px', color: '#495057' }}>
                                            <strong style={{ color: '#212529', fontWeight: 600 }}>Data de Geração:</strong> {moment().format('DD/MM/YYYY [às] HH:mm')}
                                        </p>
                                        <p style={{ margin: '8px 0', fontSize: '14px', color: '#495057' }}>
                                            <strong style={{ color: '#212529', fontWeight: 600 }}>Categorias Selecionadas:</strong> 
                                            <span style={{ color: '#0d315e', fontWeight: 500 }}> {this.state.categoriasNomesSelecionadas?.join(', ')}</span>
                                        </p>
                                        <p style={{ margin: '8px 0', fontSize: '14px', color: '#495057' }}>
                                            <strong style={{ color: '#212529', fontWeight: 600 }}>Total de Registros:</strong> {this.state.pessoasFiltradas?.length}
                                        </p>
                                    </div>

                                    {/* Table */}
                                    <table style={{ 
                                        width: '100%', 
                                        borderCollapse: 'collapse', 
                                        marginTop: '20px'
                                    }}>
                                        <thead>
                                            <tr style={{ background: '#0d315e' }}>
                                                <th style={{ 
                                                    color: 'white', 
                                                    padding: '14px 10px', 
                                                    textAlign: 'left', 
                                                    fontWeight: 600, 
                                                    fontSize: '13px', 
                                                    textTransform: 'uppercase', 
                                                    width: '100px'
                                                }}>Chave</th>
                                                <th style={{ 
                                                    color: 'white', 
                                                    padding: '14px 10px', 
                                                    textAlign: 'left', 
                                                    fontWeight: 600, 
                                                    fontSize: '13px', 
                                                    textTransform: 'uppercase', 
                                                }}>Razão Social</th>
                                                <th style={{ 
                                                    color: 'white', 
                                                    padding: '14px 10px', 
                                                    textAlign: 'left', 
                                                    fontWeight: 600, 
                                                    fontSize: '13px', 
                                                    textTransform: 'uppercase', 
                                                    width: '200px'
                                                }}>CNPJ/CPF</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.pessoasFiltradas?.map((pessoa, index) => (
                                                <tr key={pessoa.Chave} style={{ 
                                                    borderBottom: '1px solid #dee2e6',
                                                    backgroundColor: index % 2 === 1 ? '#f8f9fa' : 'white'
                                                }}>
                                                    <td style={{ padding: '12px 10px', fontSize: '13px', color: '#495057' }}>
                                                        <strong>{pessoa.Chave || '-'}</strong>
                                                    </td>
                                                    <td style={{ padding: '12px 10px', fontSize: '13px', color: '#495057' }}>
                                                        {pessoa.Nome || '-'}
                                                    </td>
                                                    <td style={{ padding: '12px 10px', fontSize: '13px', color: '#495057' }}>
                                                        {pessoa.Cnpj_Cpf || '-'}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {/* Footer */}
                                    <div style={{ 
                                        marginTop: '30px', 
                                        paddingTop: '20px', 
                                        borderTop: '2px solid #dee2e6', 
                                        display: 'flex', 
                                        justifyContent: 'space-between', 
                                        alignItems: 'center' 
                                    }}>
                                        <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#0d315e' }}>
                                            Total: {this.state.pessoasFiltradas?.length} registro(s)
                                        </div>
                                        <div style={{ textAlign: 'right', fontSize: '12px', color: '#6c757d' }}>
                                            <p style={{ margin: 0 }}><strong>{NOME_EMPRESA}</strong></p>
                                            <p style={{ margin: 0 }}>Gerado em {moment().format('DD/MM/YYYY [às] HH:mm:ss')}</p>
                                        </div>
                                    </div>
                                </div>
                            </PDFExport>
                        </div>
                    )}
                </div>
                <Rodape />
            </div>
        )

    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        user: user,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(Pessoas)